(() => {
  if (customElements.get("image-parallax")) {
    return;
  }

  class ImageParallax extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        section: "media-horizontal-scroll",
        list: ".media-horizontal-scroll__inner",
      };

      gsap.registerPlugin(ScrollTrigger);
      this.parallax();
    }

    parallax() {
      if (window.innerWidth > 800) {
        const randomNumber = Math.random() * (200 - 0) + 0;

        const parallaxY =
          this.dataset.parallaxY !== undefined
            ? this.dataset.parallaxY
            : randomNumber;

        gsap.to(this, {
          y: -parallaxY,
          scrollTrigger: {
            trigger: this,
            start: "top 150%",
            end: "bottom 0%",
            scrub: 1,
          },
        });
      }
    }
  }

  customElements.define("image-parallax", ImageParallax);
})();
